/**
 * Sanitize a string value to be used as an URL slug
 * @param value
 * @returns
 */
export const sanitizeSlug = (value = ''): string =>
  value
    // Normalize so that letters + diacritics split (e.g., "á" -> "a" + "́")
    .normalize('NFKD')
    // Remove ALL combining marks (covers Latin accents, Arabic harakat, etc.)
    .replace(/\p{M}+/gu, '')
    // Keep letters & numbers from ANY script, plus whitespace and hyphens; drop the rest
    .replace(/[^\p{L}\p{N}\s-]+/gu, '')
    // Trim whitespace
    .trim()
    // Collapse runs of spaces/underscores/hyphens to a single hyphen
    .replace(/[\s_-]+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '')
    // Lowercase (Unicode-aware)
    .toLowerCase()
